import {createSelector} from "reselect";


export const getRatePlanInitByStateSelector = (state) => state.commissionCalendar.initRatePlan
export const getChannelManagerIdSelector = (state) => state.object.channelManager ? state.object.channelManager : state.busyCalendar.channelManager
export const getChannelManagerLinkSelector = (state) => state.object.channelManagerLink ? state.object.channelManagerLink : state.busyCalendar.channelManagerLink


export const getMaxTypeSelector = (state) => state.commissionCalendar?.object?.maxType

export const getPricesIdSelector = (state) => state.commissionCalendar?.object?.priceId;

export const getTypesSelector = (state) => state.commissionCalendar?.object?.types
export const getPriceTypeSelector = (state) => state.commissionCalendar?.object?.priceType

export const getSalesActiveIdSelector = (state) => state.commissionCalendar?.object?.salesActiveId


export const getSalesActiveSelector = (state) => state.commissionCalendar?.object?.salesActive


export const getRatePlansSelector = (state) => {
    let ratePlans = state.object.ratePlans.list
    let newRatePlans = ratePlans.filter((plan) => plan.active === "Y")

    return newRatePlans
}


export const getRatePlanInitSelector = createSelector(getRatePlanInitByStateSelector, getRatePlansSelector, (ratePlan, ratePlans) => {

    if (!ratePlan) {
        return ratePlans[0]?.id
    } else {
        return ratePlan
    }

})


export const getRoomsListSelector = (state) => {
    let oldRooms = state.object.rooms
    let newRoom = []

    oldRooms.map(room => {
        newRoom.push({id: room.id, name: room.name})
    })

    return newRoom
}


export const getRoomNameSelector = (state, props) => {
    let {roomId} = props
    let rooms = state.object.rooms
    let room = rooms.filter(room => room.id === roomId)

    return room[0].name
}

export const getDatesSelectorAll = (state) => state.commissionCalendar?.object?.prices


export const getDatesSelector = createSelector(getDatesSelectorAll, getChannelManagerIdSelector, getPriceTypeSelector, (dates, channelManager, priceType) => {
    if (!dates) {
        return
    }

    let finishDates = {...dates}

    const soloPricesTypes = [333, 5186, 5187]

    if (soloPricesTypes.includes(priceType)) {
        Object.keys(dates).forEach(date => {
            finishDates = {...finishDates,
                [date]: {
                    ...finishDates[date],
                    price: finishDates[date].price.filter(item => item.type == '1' || item.type == 'dop' || item.type == 'child')
                }
            }
            if (!finishDates[date].price.find(item => item.type == '1')){
                finishDates[date].price.push({type: '1'})
            }

        })
    }


    if (channelManager && dates) {
        Object.keys(dates).forEach(date => {
            finishDates = {...finishDates, [date]: {...finishDates[date], disabled: true}}
        })
    }

    return finishDates
})


export const getSalesActiveCloseSelector = createSelector(getSalesActiveSelector, (salesActive) => {
    if (!salesActive) return
    let salesActiveClose = []
    Object.keys(salesActive).forEach(date => {
        if (salesActive[date].active === 'N') {
            salesActiveClose.push(date)
        }
    })
    return salesActiveClose

})






